
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"2156","height":"2018","viewBox":"0 0 2156 2018","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('mask',{attrs:{"id":"services-background-shape_svg__a","maskUnits":"userSpaceOnUse","x":"0","y":"0","width":"2156","height":"2018"}},[_c('path',{attrs:{"d":"M1600.81 1462.69c-241.6 218.67-598.53 209.05-916.752 78.4-317.969-130.22-598.148-380.94-569.544-596.601 28.603-215.663 364.818-396.185 746.503-489.498 380.973-93.491 807.413-99.773 957.403 120.923s23.99 668.106-217.61 886.776z","fill":"#FE840E"}})]),_c('g',{attrs:{"mask":"url(#services-background-shape_svg__a)"}},[_c('path',{attrs:{"fill":"url(#services-background-shape_svg__paint0_linear)","d":"M98-301h1597v1432H98z"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M11.312 1823.47H2033.62c18.44.45 36.14-9.98 48.57-28.61 12.44-18.63 18.41-43.67 16.41-68.74L1984.95-49.15c-4.09-54.553-37.33-96.344-77.43-97.35H-114.662c-18.444-.443-36.137 9.978-48.572 28.608-12.435 18.63-18.412 43.67-16.407 68.742l113.65 1775.27c4.08 54.49 37.248 96.26 77.303 97.35z","fill":"url(#services-background-shape_svg__paint1_linear)"}})]),_c('defs',[_c('linearGradient',{attrs:{"id":"services-background-shape_svg__paint0_linear","x1":"1730","y1":"-453.876","x2":"90.046","y2":"-18.552","gradientUnits":"userSpaceOnUse"}},[_c('stop',{attrs:{"stop-color":"#354267","stop-opacity":".01"}}),_c('stop',{attrs:{"offset":"1","stop-color":"#060E24"}})]),_c('linearGradient',{attrs:{"id":"services-background-shape_svg__paint1_linear","x1":"-369.916","y1":"-996.735","x2":"-1337.52","y2":"2088.68","gradientUnits":"userSpaceOnUse"}},[_c('stop',{attrs:{"stop-color":"#4C93F4"}}),_c('stop',{attrs:{"offset":"1","stop-color":"#0B63DA"}})])])])
          )
        }
      }
    